<template>
    <client-page class="wrap wrap--sub">
        <!-- 서브비주얼 -->
        <sub-visual :visual="'마이페이지'"></sub-visual>
        <mypage-navigation></mypage-navigation>

        <section class="section">
            <v-container>
                <tit-primary
                sc="Parts status"
                tit="부품현황">
                </tit-primary>
                
                <div class="mb-20">
                    <mes-materials-filter />
                </div>

                <v-data-table v-bind="{ headers, items }" disable-sort disable-pagination hide-default-footer mobile-breakpoint="768" :items-per-page="-1" class="mt-4">
                    <template v-for="header in headers.filter((header) => header.hasOwnProperty('formatter'))" v-slot:[`item.${header.value}`]="{ value }"> {{ header.formatter(value) }} </template>
                </v-data-table>
                
                <div class="mt-30 mt-lg-40">
                    <v-pagination flat :value="page" :length="pageCount" :total-visible="11" class="mt-4 mx-4" @input="(page) => $router.push({ query: { ...$route.query, page } })"></v-pagination>
                </div>
            </v-container>
        </section>
    </client-page>
</template>

<script>
import api from "@/api";

import ClientPage from "@/pages/client/templates/ClientPage.vue";
import SubVisual from "@/components/client/sub/sub-visual.vue";
import MypageNavigation from "@/components/client/mypage-navigation.vue";
import MesMaterialsFilter from "@/components/client/mypage/mes-materials-filter.vue";
import TitPrimary from "@/components/client/dumb/tit-primary.vue";

const defaultFormatter = (value) => value || "-";
const numberFormatter = (value) => value?.format?.() || "-";
const headers = [
    { width: "8.5%", align: "center", text: "번호", value: "index"},
    { width: "11.5", align: "center", text: "부품분류", value: "type"},
    { width: "11.5", align: "center", text: "공급업체", value: "vendor"},
    { width: "12.3", align: "center", text: "부품코드", value: "code" },
    { width: "19.2", align: "center", text: "부품명", value: "name" },
    { width: "11.5", align: "center", text: "규격", value: "size"},
    { width: "8.5%", align: "center", text: "입고수량", value: "lastBatchSize", formatter: numberFormatter },
    { width: "8.5%", align: "center", text: "사용량", value: "usedUpStockSize", formatter: numberFormatter },
    { width: "8.5%", align: "center", text: "재고량", value: "totalStockSize", formatter: numberFormatter },
    // { width: "8.5%", align: "center", text: "번호", value: "index", divider: true },
    // { width: "11.5", align: "center", text: "부품분류", value: "type", divider: true },
    // { width: "11.5", align: "center", text: "공급업체", value: "vendor", divider: true },
    // { width: "12.3", align: "center", text: "부품코드", value: "code" },
    // { width: "19.2", align: "center", text: "부품명", value: "name" },
    // { width: "11.5", align: "center", text: "규격", value: "size", divider: true },
    // { width: "8.5%", align: "center", text: "입고수량", value: "lastBatchSize", formatter: numberFormatter },
    // { width: "8.5%", align: "center", text: "사용량", value: "usedUpStockSize", formatter: numberFormatter },
    // { width: "8.5%", align: "center", text: "재고량", value: "totalStockSize", formatter: numberFormatter },
].map((item) => ({ ...item, formatter: item?.formatter || defaultFormatter }));

export default {
    components: {
        ClientPage,
        SubVisual,
        MypageNavigation,
        MesMaterialsFilter,
		TitPrimary,
    },
    data() {
        return {
            materials: [],

            limit: 10,
            summary: { totalCount: 0 },

            headers,
        };
    },
    computed: {
        items() {
            return this.materials.map((item, index) => ({ ...item, index: this.summary.totalCount - (this.page - 1) * this.limit - index }));
        },
        page() {
            return +(this.$route.query.page || "1");
        },
        skip() {
            return (this.page - 1) * this.limit;
        },
        pageCount() {
            return Math.ceil(this.summary.totalCount / this.limit) || 1;
        },
        params() {
            let { query } = this.$route;
            return { ...query };
        },
    },
    mounted() {
        this.init();
    },
    watch: {
        params() {
            this.search();
        },
    },
    methods: {
        async init() {
            try {
                this.search();
            } catch (error) {
                console.error(error);
            }
        },

        async search() {
            try {
                let { skip, limit, params } = this;
                var { summary, materials } = await api.v1.me.mes.materials.gets({
                    headers: { skip, limit },
                    params,
                });

                this.materials = materials;
                this.summary = summary;
            } catch (error) {
                console.error(error);
            }
        },
    },
};
</script>

<style scoped lang="scss">
@media (min-width:576px){
}
@media (min-width:768px){
}
@media (min-width:1024px){
}
@media (min-width:1200px){
}

</style>
